export default __webpack_public_path__ + "static/media/pinecones.c568378b.png";